module.exports = __webpack_public_path__ + "images/home_icon_card_subtract_p@2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/home_icon_card_subtract_p@2x.png
// module id = 858
// module chunks = 124